<template>
  <div class="calendar">
    <div class="modal">
      <div class="black_bg" @click="$emit('closeCalendar')"></div>
      <div class="content">
        <div class="month_wrap">
          <inline-svg
            :src="require('@/assets/img/icon/arrow_left.svg')"
            :class="{ disabled: !bookableMonthList.includes(preMonth) }"
            @click="changeCalendar(preMonth)"
          />
          <span>{{ dayjs(nowMonth).format("YYYY년 MM월") }}</span>
          <inline-svg
            :src="require('@/assets/img/icon/arrow_right.svg')"
            :class="{ disabled: !bookableMonthList.includes(nextMonth) }"
            @click="changeCalendar(nextMonth)"
          />
        </div>
        <table>
          <thead>
            <tr>
              <th v-for="(day, idx) in weekDay" :key="idx">
                {{ day }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(week, weekIdx) in calendarInfo.calendar" :key="weekIdx">
              <td
                v-for="(date, idx) in week"
                :key="idx"
                :class="{
                  active: isActiveDate(date),
                  disabled: !isBookableDate(date),
                }"
                @click="setDate(date)"
              >
                <div>{{ date.slice(8, 10) }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <BaseButton name="완료" @click="onSelectDate" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import BaseButton from "@/components/Base/BaseButton.vue";
import InlineSvg from "vue-inline-svg";
import dayjs from "dayjs";

export default {
  name: "BaseCalendar",
  components: {
    InlineSvg,
    BaseButton,
  },
  props: {
    selectedIdx: {
      type: Number,
      default: 0,
    },
    selectedDate: {
      type: String,
      default: "",
    },
    selectedDateList: {
      type: Array,
    },
    calendarList: {
      type: Array,
    },
  },
  setup(props, { emit }) {
    const calendarInfo = ref(props.calendarList[0]);
    const weekDay = ["일", "월", "화", "수", "목", "금", "토"];
    const bookableMonthList = props.calendarList.map(
      (calendarInfo) => calendarInfo.bookableMonth
    );
    const nowMonth = computed(() =>
      dayjs(calendarInfo.value.bookableMonth).format("YYYY-MM")
    );
    const preMonth = computed(() =>
      dayjs(calendarInfo.value.bookableMonth)
        .subtract(1, "month")
        .format("YYYY-MM")
    );
    const nextMonth = computed(() =>
      dayjs(calendarInfo.value.bookableMonth).add(1, "month").format("YYYY-MM")
    );

    const changeCalendar = (month) => {
      calendarInfo.value = props.calendarList.find(
        (calendar) => calendar.bookableMonth === month
      );
    };

    const isBookableDate = (date) => {
      // TODO 이미 선택한 날짜도 false
      return !!calendarInfo.value.bookableDates.find((bookableDate) => {
        if (props.selectedDate === date) {
          return bookableDate.date === date;
        }
        return (
          bookableDate.date === date && !props.selectedDateList.includes(date)
        );
      });
    };
    const isActiveDate = (date) => {
      if (!dateValue.value) {
        return false;
      }
      return (
        dateValue.value === date &&
        dayjs(dateValue.value).month() ===
          dayjs(calendarInfo.value.bookableMonth).month()
      );
    };

    const dateValue = ref(props.selectedDate);
    const onSelectDate = () => {
      emit("onSelectDate", dateValue.value);
      // if (selectDate.value) {
      // 	emit('setDate', { idx: props.selectedIdx });
      // }
    };
    const setDate = (date) => {
      if (isBookableDate(date)) {
        dateValue.value = date;
        // emit('update:selectedDate', date);
      }
    };
    return {
      weekDay,
      nowMonth,
      preMonth,
      nextMonth,
      calendarInfo,
      bookableMonthList,
      onSelectDate,
      setDate,
      isBookableDate,
      isActiveDate,
      changeCalendar,
      dayjs,
    };
  },
};
</script>
